import GLightbox from "glightbox";


export default class GalleryLightboxes {
    constructor($element) {
        this.$element = $element;

        new GLightbox({
            selector : this.$element.dataset.galleryLightboxes,
        });
    }
}